export default __webpack_public_path__ + "static/media/img-earn-more-6.5b180e1a.png";